import { Box } from '@mui/material';

import { selectExternalInfos } from '@/domain/external/external.selectors';
import { useAppSelector } from '@/ui/hook/store';

import { FooterSticky } from './FooterSticky';
import { Layout } from './Layout';

export function Step2Form({
  children,
  disableValidate,
  onClickValidate,
}: {
  children: React.ReactNode;
  onClickValidate: () => void;
  disableValidate?: boolean;
}) {
  const infos = useAppSelector(selectExternalInfos);
  const BOTTOM_MARGIN_FOR_FOOTER = 100;
  return (
    <Layout userName={infos.userName}>
      {children}
      <Box sx={{ height: BOTTOM_MARGIN_FOR_FOOTER }} />
      <FooterSticky
        disableValidate={disableValidate}
        onClickValidate={onClickValidate}
      />
    </Layout>
  );
}
